<template>
  <section class="block permission">
    <h2>権限</h2>
    <nav class="menu">
      <select v-model="selected">
        <option disabled value="">Please select one</option>
        <option v-for="(item, index) in organizations" :key='index' :value="item.slug">{{ item.name }}</option>
      </select>
      <button class="btn btn-secondary" style="margin-left: 12px;" @click="addPerm">追加</button>
    </nav>
    <Table :data="data" :headers="headers" :buttonCols="buttonCols" @delPerm="delPerm"></Table>
  </section>
  <Dialog ref="error" class="dialog">
    <h4 class="title">Error</h4>
    <div class="message">
      <p class="text">{{ error.message }}</p>
    </div>
    <div class="action">
      <button class="btn btn-light" @click="errorClose">Close</button>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Table from '@/components/Table.vue';
import Dialog from '@/components/Dialog.vue';
import { Permission } from '@/lib/permission';
import { Organization, OrganizationData } from '@/lib/organization';

export default defineComponent({
  name: 'Permission',
  components: {
    Table,
    Dialog,
  },
  props: {
    slug: String,
  },
  data() {
    return {
      data: [] as string[][],
      buttonCols: [] as string[][],
      headers: [] as string[],
      selected: '' as string,
      organizations: [] as OrganizationData[],
      error: {
        message: '',
      },
    }
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      if (!this.slug) return;
      try {
        this.data = [];
        this.headers = [];
        this.buttonCols = [];

        const perm = new Permission(this.slug);
        const data = await perm.get();
        if (data) {
          for (const row of data) {
            this.data.push([row.organization, '削除']);
            this.buttonCols.push(['', `delPerm|${row.org_slug}`]);
          }
          this.headers.push('組織名', '');
        }

        const org = new Organization();
        const orgs = await org.all();
        if (orgs) {
          this.organizations = orgs;
        }
      } catch (e) {
        if (e instanceof Error) {
          this.error.message = e.message;
          (this.$refs.error as InstanceType<typeof Dialog>)?.open();
        }
        console.warn(e);
      }
    },
    errorClose() {
      (this.$refs.error as InstanceType<typeof Dialog>)?.close();
    },
    async addPerm() {
      if (this.selected === '') return;
      try {
        const perm = new Permission(this.slug!);
        const data = await perm.add(this.selected);
        console.info(data);
        await this.loadData();
      } catch (e) {
        if (e instanceof Error) {
          this.error.message = e.message;
          (this.$refs.error as InstanceType<typeof Dialog>)?.open();
        }
        console.warn(e);
      }
    },
    async delPerm(slug: string) {
      try {
        const perm = new Permission(this.slug!);
        const data = await perm.delete(slug);
        console.info(data);
        await this.loadData();
      } catch (e) {
        if (e instanceof Error) {
          this.error.message = e.message;
          (this.$refs.error as InstanceType<typeof Dialog>)?.open();
        }
        console.warn(e);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/assets/const.scss' as *;
@use '@/assets/dialog.scss' as *;

.permission .menu {
  display: flex;
  flex-wrap: wrap;
  margin: 0 0.5rem 10px;
  @media (min-width: $tablet) {
    margin: 0 20px 10px;
  }
  @media (min-width: $desktop) {
    margin: 0 40px 10px;
  }

  a {
    margin-right: 10px;
    text-decoration: none;
    color: inherit;
    &:last-child {
      margin-right: 0;
    }

    span {
      margin-left: 5px;
    }
  }
}

.dialog {
  @include dialog();
}
</style>
